import { useEffect, useRef, useState } from 'react';
import { AugmentedRealityType } from '../../../types/augmentedReality';
import TopBar from 'components/AugmentedReality/Structure/TopBar';
import BottomBar from 'components/AugmentedReality/Photo/BottomBar';
import {
  SCPhotoContainer,
  SCOverlayImage,
  SCVideo,
} from 'components/AugmentedReality/Photo/styled'
import useCamera from 'components/AugmentedReality/hooks/useCamera';
import { useTranslation } from 'react-i18next';

interface PhotoFrameProps {
  ra: AugmentedRealityType
  camera: ReturnType<typeof useCamera>
  onPrevious: () => void
  onPhotoTaken: (photo: string, overlay: string) => void
  currentFilter: number
  overlayTransform: { x: number; y: number; scale: number }
}

const PhotoFrame = ({ ra, camera, onPrevious, onPhotoTaken, currentFilter, overlayTransform }: PhotoFrameProps) => {
  const { t } = useTranslation();
  const [snapshotUrl] = useState<string | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const startCameraAsync = async () => {
      if (!camera.stream) {
        await camera.startCamera();
      }
    };
    startCameraAsync();
  }, []);

  useEffect(() => {
    if (videoRef.current && camera.stream) {
      videoRef.current.srcObject = camera.stream;
    }
  }, [camera.stream]);

  return (
    <SCPhotoContainer>
      <TopBar label={t('augmentedReality.photo.keepMemory')} />

      {snapshotUrl ? (
        <SCVideo as="img" src={snapshotUrl} alt="Captured photo" />
      ) : (
        <SCVideo ref={videoRef} autoPlay playsInline muted/>
      )}

      {ra.stickers?.hideOverlay === false && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            transform: `translate(${overlayTransform.x}px, ${overlayTransform.y}px) scale(${overlayTransform.scale})`,
            transformOrigin: '0px 0px',
            pointerEvents: 'none',
            zIndex: 2,
          }}
        >
          <SCOverlayImage crossOrigin="anonymous" src={ra.experiences[currentFilter].image} alt="filter overlay"  $size={300}/>
        </div>
      )}

      <BottomBar
        camera={camera}
        videoRef={videoRef}
        currentOverlay={ra.experiences[currentFilter].image}
        onPrevious={onPrevious}
        onPhotoTaken={onPhotoTaken}
        useRotate={ra.stickers?.useRotate}
      />
    </SCPhotoContainer>
  )
};

export default PhotoFrame;
